import React from "react";
import { Text as ChakraText, TextProps } from "@chakra-ui/react";

const Text = ({ ...rest }: TextProps) => {
  return <ChakraText {...rest} />;
};

export default Text;
